import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DepositPromotionMutationKeys } from '../../../keys'
import { deleteDepositPromotion } from '../../services'

interface UseMutationDeleteDepositPromotionProps {
	id: string
}

export default function useMutationDeleteDepositPromotion(
	props?: UseBaseMutationOptions<void, UseMutationDeleteDepositPromotionProps>,
) {
	return useMutation({
		mutationKey: [DepositPromotionMutationKeys.DeleteDepositPromotion],
		mutationFn: ({ id }) => deleteDepositPromotion(id),
		...props,
	})
}
